import { render, staticRenderFns } from "./ny-banner.vue?vue&type=template&id=874e0928&scoped=true&"
import script from "./ny-banner.vue?vue&type=script&lang=js&"
export * from "./ny-banner.vue?vue&type=script&lang=js&"
import style0 from "./ny-banner.vue?vue&type=style&index=0&id=874e0928&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "874e0928",
  null
  
)

export default component.exports